import { axios } from "utils";

import { PUBLIC_REDZONES_URL as endpoint } from "consts";

import { FieldRedzone, RedzoneException, RedzoneResponse } from "models";

export const getFieldRedzones = async (data: { signal: AbortSignal }): Promise<FieldRedzone[]> =>
  axios.get(`${endpoint}/fields`, { data, signal: data.signal });

export const getRedzoneExceptions = async (data?: { signal: AbortSignal }): Promise<RedzoneException[]> => axios.get(`${endpoint}/exceptions`, { data });

export const confirmFieldRedzones = async (data: { ids: string[]; signal: AbortSignal }) =>
  axios.post(`${endpoint}/fields/confirm`, { data, signal: data.signal });

export const getRedzones = async (data: {
  lat?: number;
  lng?: number;
  state?: string;
  includeGeometry?: boolean | null;
  signal: AbortSignal;
}): Promise<RedzoneResponse[]> => axios.get(`${endpoint}`, { data, signal: data.signal });
